var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32.000000pt",
    height: "32.000000pt",
    viewBox: "0 0 32.000000 32.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,32.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 265 c0 -12 16 -15 93 -15 59 0 97 -4 105 -12 7 -7 12 -41 12 -81 0 -50 3 -68 13 -64 8 2 12 30 12 93 l0 89 -117 3 c-101 2 -118 0 -118 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 217 c-3 -8 -4 -49 -2 -93 l3 -79 118 -3 117 -3 0 96 0 95 -115 0 c-87 0 -117 -3 -121 -13z m196 -57 c0 -6 -32 -10 -75 -10 -43 0 -75 4 -75 10 0 6 32 10 75 10 43 0 75 -4 75 -10z m-70 -55 c0 -11 -11 -15 -40 -15 -29 0 -40 4 -40 15 0 11 11 15 40 15 29 0 40 -4 40 -15z m68 3 c-7 -19 -38 -22 -38 -4 0 10 9 16 21 16 12 0 19 -5 17 -12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCard);
export default __webpack_public_path__ + "static/media/business-card.63d2f97cd5eeb1366465b91be196376b.svg";
export { ForwardRef as ReactComponent };